import * as React from "react";
const SvgSizeSm = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 8.333, height: 8.333, x: 5.833, y: 5.833, stroke: "currentColor", strokeWidth: 1.25, rx: 4.167 }));
export default SvgSizeSm;
